import { AppDispatch } from '@ui/store';
// eslint-disable-next-line no-restricted-imports
import { useDispatch as reduxUseDispatch } from 'react-redux';

export const useDispatch = reduxUseDispatch.withTypes<AppDispatch>();
